export default {"src":"/_next/static/media/ceca-logo-blanco.6201cc20.svg","height":37,"width":142};